module.exports = __webpack_public_path__ + "static/media/radar_chart.b75602fc.svg";